import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './Transaction.css';

// Locale
import messages from '../../locale/messages';

//Image
import image from '/public/SiteImages/noTransactionImage.svg';

const NoTransaction = ({ noText }) => {

    return (
        <>
            <div className={s.center}>
                <img src={image} className={s.widthMobile} />
                <div className={cx(s.noRecordText, s.noListHeading)}><FormattedMessage {...messages.noTransactionText} /></div>
                <div className={cx(s.noListSubHeading)}>{noText}</div>
            </div>

        </>
    );
}
NoTransaction.propTypes = {
    formatMessage: PropTypes.any,
};

export default (withStyles(s)(NoTransaction));